import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { PassengerChangeFormKeysEnum } from '@enums/passengerChangeFormKeys.enum';
import { UrlEnum } from '@enums/url.enum';
import { Observable, of } from 'rxjs';
import { LocalStorageService } from '../local-storage/local-storage.service';
import { UrlService } from '../url/url.service';
import {
  MappedPassenger,
  PassengerForm,
  PassengerFormValues,
  PassengersResponse,
  PassengerUpdateRequest,
  PassengerUpdateResponse,
} from './_interfaces_/passenger-change.interface';

@Injectable({
  providedIn: 'root',
})
export class PaxChangeService {
  private _lastPassengerUpdateResponse: PassengerUpdateResponse | null = null;

  constructor(
    @Inject(HttpClient) private _http: HttpClient,
    @Inject(LocalStorageService) private _localStorageService: LocalStorageService,
    @Inject(UrlService) private _urlService: UrlService
  ) {}

  getPassengersData(flightIdentifier: string): Observable<PassengersResponse> {
    if (flightIdentifier) {
      const culture = this._localStorageService.getCulture();
      const url = `${this._urlService.urls[UrlEnum.PAX_CHANGE_DATA]}?flightIdentifier=${flightIdentifier}&culture=${culture}`;
      const sessionId = this._localStorageService.getUserSessionToken();
      const headers = { SessionId: sessionId };
      return this._http.get<PassengersResponse>(url, { headers });
    }
  }

  submitNewPassengersData(flightIdentifier: string, formData: PassengerFormValues[]): Observable<PassengerUpdateResponse> {
    if (flightIdentifier && formData) {
      const url = `${this._urlService.urls[UrlEnum.UPDATE_PAX_DATA]}`;
      const sessionId = this._localStorageService.getUserSessionToken();
      const headers = { SessionId: sessionId };
      const payload: PassengerUpdateRequest = {
        flightIdentifier,
        passengerUpdates: formData.map((passenger: PassengerFormValues) => ({
          identifier: passenger[PassengerChangeFormKeysEnum.identifier],
          genderType: passenger[PassengerChangeFormKeysEnum.gender],
          firstName: passenger[PassengerChangeFormKeysEnum.firstName],
          lastName: passenger[PassengerChangeFormKeysEnum.lastName],
        })),
      };
      return this._http.put<PassengerUpdateResponse>(url, payload, { headers });
    }
  }

  confirmPassengerUpdate(flightIdentifier: string): Observable<any> {
    const url = `${this._urlService.urls[UrlEnum.CONFIRM_PAX_DATA]}`;
    const sessionId = this._localStorageService.getUserSessionToken();
    const headers = { SessionId: sessionId };
    const payload = { selectedFlightIdentifier: flightIdentifier };
    return this._http.post<any>(url, payload, { headers });
  }

  setLastPassengerUpdateData(response: PassengerUpdateResponse): void {
    this._lastPassengerUpdateResponse = response;
  }

  getLastPassengerUpdateResponse(): Observable<PassengerUpdateResponse | null> {
    return of(this._lastPassengerUpdateResponse);
  }

  clearPassengerUpdateData(): void {
    this._lastPassengerUpdateResponse = null;
  }
}
